import { render } from "./DonationFrequencySelect.vue?vue&type=template&id=44b17626&scoped=true"
import script from "./DonationFrequencySelect.vue?vue&type=script&lang=js"
export * from "./DonationFrequencySelect.vue?vue&type=script&lang=js"

import "./DonationFrequencySelect.vue?vue&type=style&index=0&id=44b17626&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b17626"]])

export default __exports__